export const GET_MODULE = "GET_MODULE";
export const GET_MODULE_SUCCESS = "GET_MODULE_SUCCESS";
export const GET_MODULE_FAIL = "GET_MODULE_FAIL";
